import { useQuery } from "@tanstack/react-query";
import { getPrimumSubscription } from "../api/primum";
import { useAuth } from "../contexts/AuthContext";

const QUERY_KEY = ["primum-subscription"];

// skips both caches and stores the fresh answer for every Meet Now button
export async function refreshPrimumSubscription(queryClient) {
  const res = await getPrimumSubscription(true);
  queryClient.setQueryData(QUERY_KEY, res.data);
  return res.data;
}

const usePrimumSubscription = () => {
  const { hasFeature } = useAuth();
  const enabled = !!hasFeature(["primum"]);

  const query = useQuery(
    QUERY_KEY,
    async () => (await getPrimumSubscription()).data,
    {
      enabled,
      staleTime: 300000, // 5 mins, matches the API's cache
      retry: false,
    },
  );

  return { enabled, ...query };
};

export default usePrimumSubscription;
